import React from "react";
import FilterButtons from "./FilterButtons";
import BlogSections from "./BlogSections";

const Perspectives = () => {
  return (
    <div
      id="perspectives"
      className="flex dark:bg-dark flex-col gap-[50px] py-[100px]"
    >
      <div className="relative text-center">
        <h1 className="text-4xl font-extrabold md:text-7xl font-mono text-center text-dark leading-normal dark:text-light">
          Perspectives
        </h1>
        <div
          className="dark:bg-custom-gradient"
          style={{
            position: "absolute",
            width: "70%",
            height: "157.05px",
            left: "50%", // Center horizontally
            top: "50%", // Center vertically
            transform: "translate(-50%, -50%) matrix(1, 0, -0.03, 1, 0, 0)", // Adjust for precise positioning
            opacity: 0.2,
            filter: "blur(34px)",
            borderRadius: "50%",
            zIndex: "0", // Ensure it's behind the text
          }}
        ></div>
      </div>

      <FilterButtons />

      <BlogSections />
    </div>
  );
};

export default Perspectives;
